module.exports = __webpack_public_path__ + "static/img/16.9c3fa9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/16.png
// module id = VKfu
// module chunks = 0